import { RequestConfig, RequestConfigType } from '@client/common/utils/api/RequestConfig';

export class UserStats {
  public static getUserStats(): RequestConfigType {
    return RequestConfig.get('/user-stats');
  }
}
